import DynamicPageInput from './DynamicPageInputCopy.jsx';
import Skeleton from '@mui/material/Skeleton';

const MasterCompanyLevelInput = ({ values, setValues, config, inputLists, error, isLoading, consortium, onChange=()=>{return} }) => {
    return (
        !isLoading && Object.keys(config).length > 0 ? 
            <div>
                <div className='d-flex gap-3' style={{flexWrap:'wrap'}}>
                    {config?.slice(0, 2)?.map(el =>
                        <>
                            <div>
                                {el['columnid'] != 'consortiumid' || consortium ?
                                    <DynamicPageInput data={values} setData={setValues} config={el} onChangeFunction={onChange} args={inputLists} showError={error[0][el['columnid']]} />
                                    : <></>}
                            </div>
                        </>
                    )}
                    {config?.slice(2)?.map(el =>
                        <>
                            <div>
                                {el['columnid'] != 'consortiumid' || consortium ?
                                    <DynamicPageInput data={values} setData={setValues} config={el} onChangeFunction={onChange} args={inputLists} showError={error[0][el['columnid']]} width={el.tag == 'Rebate Frequency' ? '7rem' : el.tag == 'Portfolio' ? '10rem': '15rem'}/>
                                    : <></>}
                            </div>
                        </>
                    )}
                </div>
            </div>
        : isLoading ? 
            <div className='d-flex flex-row gap-3 align-items-center justify-content-between'>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
                <Skeleton variant="rectangular" width='100%' height={'40px'} sx={{ borderRadius: '5px' }}/>
            </div>
        : <></>     
    ); 
}   

export default MasterCompanyLevelInput; 